function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9862 6.1368L6.83514 0.98745C6.60911 0.761996 6.24292 0.761996 6.01632 0.98745C5.7903 1.2129 5.7903 1.5791 6.01632 1.80455L10.7588 6.54532L6.01689 11.2861C5.79087 11.5115 5.79087 11.8777 6.01689 12.1038C6.24292 12.3292 6.60968 12.3292 6.83571 12.1038L11.9868 6.95442C12.2094 6.7313 12.2094 6.35935 11.9862 6.1368Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.22378 6.25396L2.54446 2.57586C2.38301 2.41482 2.12144 2.41482 1.95959 2.57586C1.79814 2.7369 1.79814 2.99846 1.95959 3.1595L5.34707 6.54577L1.95999 9.93203C1.79855 10.0931 1.79855 10.3546 1.95999 10.5161C2.12144 10.6771 2.38342 10.6771 2.54486 10.5161L6.22419 6.83798C6.38319 6.67861 6.38319 6.41293 6.22378 6.25396Z",
  fill: "white"
})));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11.4545,
  height: 11.4545,
  fill: "white",
  transform: "translate(3.27283 0.818359)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8.18182,
  height: 8.18182,
  fill: "white",
  transform: "translate(0 2.45508)"
})));

var SvgChevronRight = function SvgChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right.c57311a6.svg";
export { ForwardRef as ReactComponent };